export default __webpack_public_path__ + "static/media/happy.144092d2.mp3";